"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/order */
const react_1 = require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const ApplicationLayoutHeader_1 = tslib_1.__importDefault(require("./ApplicationLayoutHeader"));
const ApplicationLayoutSidebar_1 = tslib_1.__importDefault(require("./ApplicationLayoutSidebar"));
const ApplicationLayoutBody_1 = tslib_1.__importDefault(require("./ApplicationLayoutBody"));
// initializes document bootstrapping - keep the import to avoid being tree-shaken
const init_1 = require("../../utils/init");
init_1.initDocumentBootstrapping;
const ApplicationLayout = (0, react_1.forwardRef)((props, ref) => {
    const { className, layoutRef, children } = props, remainingProps = tslib_1.__rest(props, ["className", "layoutRef", "children"]);
    const classes = (0, classnames_1.default)('ApplicationLayout', className);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, remainingProps, { ref: ref || layoutRef, className: classes }, { children: children })));
});
ApplicationLayout.Header = ApplicationLayoutHeader_1.default;
ApplicationLayout.Sidebar = ApplicationLayoutSidebar_1.default;
ApplicationLayout.Body = ApplicationLayoutBody_1.default;
exports.default = ApplicationLayout;
